import theme from "theme";

const { default: styled } = require("@emotion/styled");

const CardContainerStyle = styled.div`
  margin: auto;
  padding: 20px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(15px);
  border-radius: ${theme.modernTokens.borderRadius.lg};
  box-shadow: ${theme.modernTokens.shadows.md};
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: ${theme.modernTokens.transitions.normal};

  &:hover {
    box-shadow: ${theme.modernTokens.shadows.lg};
  }
  
  @media (max-width: 1024px) {
    padding: 18px;
  }
  
  @media (max-width: 768px) {
    padding: 16px;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const HeaderStyle = styled.div`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #E36E00 0%, #FFAE00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.3px;
  
  @media (max-width: 1024px) {
    font-size: 19px;
    margin-bottom: 18px;
  }
  
  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 14px;
  }
`;

const RowContainerStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0px;
  justify-content: flex-start;
`;

const RowStyle = styled.div`
  flex: 1 1 40%;
  font-size: 14px;
  color: ${theme.colors.modernGray[600]};
  padding: 12px;
  display: flex;
  align-items: center;
`;

const LabelContainerStyle = styled.span`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  font-weight: 600;
  color: ${theme.colors.modernGray[800]};
  font-size: 14px;
`;

const ValueContainerStyle = styled.span`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  color: ${theme.colors.modernGray[600]};
  font-size: 14px;
  font-weight: 500;
`;

const Container = styled.div`
  width: 100%;
  min-width: 0;
  margin: 0 auto;
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 0;
  width: 100%;
  min-width: 0;

  @media (max-width: 1200px) {
    gap: 14px;
  }

  @media (max-width: 1024px) {
    gap: 12px;
  }

  @media (max-width: 768px) {
    gap: 10px;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const DetailItem = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: ${theme.modernTokens.borderRadius.md};
  border: 1px solid rgba(227, 110, 0, 0.1);
  transition: ${theme.modernTokens.transitions.normal};
  width: 100%;
  min-width: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(227, 110, 0, 0.2);
    transform: translateY(-1px);
    box-shadow: ${theme.modernTokens.shadows.sm};
  }
  
  @media (max-width: 1200px) {
    padding: 14px;
  }
  
  @media (max-width: 1024px) {
    padding: 12px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
    gap: 6px;
  }
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (max-width: 768px) {
    gap: 6px;
  }
  
  @media (max-width: 480px) {
    gap: 4px;
  }
`;

const LabelIcon = styled.div`
  font-size: 16px;
  color: ${theme.colors.modernPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  
  @media (max-width: 768px) {
    font-size: 14px;
    width: 18px;
    height: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
    width: 16px;
    height: 16px;
  }
`;

const Label = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${theme.colors.modernGray[800]};
  
  @media (max-width: 1024px) {
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const Value = styled.div`
  font-size: 14px;
  color: ${theme.colors.modernGray[600]};
  font-weight: 500;
  
  @media (max-width: 1024px) {
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const SC = {
  CardContainerStyle,
  HeaderStyle,
  RowContainerStyle,
  RowStyle,
  LabelContainerStyle,
  ValueContainerStyle,
  Container,
  DetailsGrid,
  DetailItem,
  LabelContainer,
  LabelIcon,
  Label,
  Value,
};

export default SC;
